/**
 * Nav icons as inline SVG.
 *
 * No icon font and no icon package: eight glyphs do not justify a dependency,
 * and inline paths inherit currentColor, which is what makes the sidebar's
 * white-alpha states work without a second set of assets.
 *
 * All 24x24, 1.5 stroke, no fill — one visual family.
 */

const PATHS = {
  dashboard: 'M4 13h6V4H4v9Zm0 7h6v-5H4v5Zm10 0h6v-9h-6v9Zm0-16v5h6V4h-6Z',
  trophy:    'M8 4h8v5a4 4 0 0 1-8 0V4Zm0 1H5v2a3 3 0 0 0 3 3m8-5h3v2a3 3 0 0 1-3 3M12 13v4m-3 3h6',
  users:     'M16 19v-1a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v1M9.5 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm11 9v-1a4 4 0 0 0-3-3.9M16 3.6a4 4 0 0 1 0 7.7',
  calendar:  'M4 6h16v14H4V6Zm0 4h16M8 3v4m8-4v4',
  settings:  'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm8.4-3a8.4 8.4 0 0 0-.1-1.3l2-1.5-2-3.4-2.3 1a8.4 8.4 0 0 0-2.2-1.3L15.4 3h-4l-.4 2.5a8.4 8.4 0 0 0-2.2 1.3l-2.3-1-2 3.4 2 1.5a8.4 8.4 0 0 0 0 2.6l-2 1.5 2 3.4 2.3-1a8.4 8.4 0 0 0 2.2 1.3l.4 2.5h4l.4-2.5a8.4 8.4 0 0 0 2.2-1.3l2.3 1 2-3.4-2-1.5c.06-.43.1-.86.1-1.3Z',
  chart:     'M4 20V10m5 10V4m5 16v-7m5 7V8',
  user:      'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-8 8a8 8 0 0 1 16 0',
  building:  'M4 21V5l8-3v19M4 21h16M12 21V9l8 3v9M7 8h2m-2 4h2m-2 4h2m8-3h1m-1 4h1',
  tv:        'M3 6h18v12H3V6Zm6 15h6M9 3l3 3 3-3',
  target:    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-4.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
  heart:     'M12 20s-7-4.3-7-9a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 4.7-7 9-7 9Z',
  menu:      'M4 7h16M4 12h16M4 17h16',
  logout:    'M15 17l5-5-5-5m5 5H9m1-9H5v18h5',
  // The sidebar's collapse pair. Chevrons rather than « », which have no
  // matching weight in the icon family and read as text beside the nav links.
  'chevron-left':  'M15 6l-6 6 6 6',
  'chevron-right': 'M9 6l6 6-6 6',
};

export default function Icon({ name, size = 16, className = 'hd-nav-icon' }) {
  const d = PATHS[name];
  if (!d) return null;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}
